import React from 'react';
import { createPortal } from 'react-dom';
import { AlertTriangle, Bell } from 'lucide-react';

const NavigationBlocker = ({
  isOpen,
  onConfirm,
  onCancel,
  type = 'generation',
  title,
  message,
  showConfirmButton = true,
  confirmText,
  cancelText
}) => {
  if (!isOpen) return null;

  const getContent = () => {
    if (type === 'credential-lock') {
      return {
        icon: <AlertTriangle size={56} color="#ef4444" />,
        title: title || 'Access Restricted',
        message: message || 'You cannot navigate away from Organization Settings until all mandatory integration credentials are fixed. Please update the invalid credentials before continuing.',
        confirmText: null,
        cancelText: cancelText || 'I Understand',
        showConfirm: false
      };
    }

    if (type === 'analyzer-background') {
      return {
        icon: <Bell size={56} color="#9404C3" />,
        title: title || 'Analysis in Progress',
        message: message || 'Your analysis is still generating. Leave now and we\'ll notify you when it\'s complete.',
        confirmText: confirmText || 'Leave & Get Notified',
        cancelText: cancelText || 'Stay Here',
        showConfirm: true
      };
    }

    return {
      icon: <AlertTriangle size={56} color="#ff9500" />,
      title: title || 'Generation in Progress',
      message: message || 'Project generation is currently running. Navigating away will stop this process and you\'ll lose your progress.',
      confirmText: confirmText || 'Leave Anyway',
      cancelText: cancelText || 'Stay Here',
      showConfirm: showConfirmButton
    };
  };

  const content = getContent();

  return createPortal(
    <div className="navigation-blocker-overlay">
      <div className="navigation-blocker-modal">
        <div className="navigation-blocker-icon">
          {content.icon}
        </div>

        <h2 className="navigation-blocker-title">{content.title}</h2>
        <p className="navigation-blocker-message">{content.message}</p>

        <div className="navigation-blocker-actions">
          {content.showConfirm && (
            <button
              className="navigation-blocker-btn navigation-blocker-btn-danger"
              onClick={onConfirm}
            >
              {content.confirmText}
            </button>
          )}
          <button
            className="navigation-blocker-btn navigation-blocker-btn-primary"
            onClick={onCancel}
          >
            {content.cancelText}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default NavigationBlocker;